export default __webpack_public_path__ + "images/flight_out-primary.15f0b55.png";